<!-- Original Template -->
<div
  *ngIf="!enableMachCoreProfileSelector"
  [ngClass]="{ active: show }"
  class="businessProfileSelectorScreen__content"
>
  <p class="businessProfileSelectorScreen__content-title">
    {{ pageData.title }}
  </p>

  <!-- Company List -->
  <div
    class="businessProfileSelectorScreen__content--company"
    *ngFor="
      let company of pageData.businessProfile;
      let i = index;
      let first = first;
      let last = last
    "
  >
    <!-- Company Header -->
    <div
      (click)="
        isBusinessOnlyPath(company.permissionTypes)
          ? noExpand(
              {
                companyName: company.companyName,
                permType: company.permissionTypes,
                accountIndex: i,
                corporateId: company.corporateId,
                displayInlineText: company.displayInlineText,
                isOaSmeAccount: company.isOaSmeAccount,
                partnerId: company.partnerId,
                restrictOnePax: company.restrictOnePax,
                disableMiles: company.disableMiles
              },
              $event
            )
          : expand(i, $event)
      "
      [ngClass]="{
        selected:
          businessStateSelected.selectedState &&
          businessStateSelected.accountIndex === i,
        first: first,
        last: last,
        'only-business': isBusinessOnlyPath(company.permissionTypes)
      }"
      class="businessProfileSelectorScreen__content--company-name"
      [attr.data-acdl-action]="
        'header profile flyout select a profile cta click'
      "
      [attr.data-acdl-page-section]="'header:profile selector flyout'"
      [attr.data-acdl-name]="'business profile'"
    >
      <idp-accordion
        [type]="'secondary'"
        [viewLabel]="company.displayName"
        [hideLabel]="company.displayName"
        [caretType]="'secondary'"
        [modalTitle]="
          businessStateSelected.selectedState &&
          businessStateSelected.accountIndex === i
            ? company.displayName + ' Selected'
            : company.displayName
        "
        [state]="i === permissionDiv && show"
        [targetContent]="'businessProfile_' + i"
        [id]="'businessProfileBtn_' + i"
      ></idp-accordion>

      <span
        class="business-check-mark"
        [ngClass]="{
          selected:
            businessStateSelected.selectedState &&
            businessStateSelected.accountIndex === i,
          'only-business': isBusinessOnlyPath(company.permissionTypes)
        }"
      ></span>
    </div>

    <!-- Permission Types -->
    <a
      class="businessProfileSelectorScreen__content--permission"
      [ngClass]="{
        active: show,
        details: i === permissionDiv && show
      }"
      *ngFor="let permissionCompany of company.permissionTypes"
      [id]="'businessProfile_' + i"
      href="javascript:void(0)"
      (click)="
        onClick(
          {
            companyName: company.companyName,
            permType: permissionCompany.permType,
            accountIndex: i,
            corporateId: company.corporateId,
            displayInlineText: company.displayInlineText,
            isOaSmeAccount: company.isOaSmeAccount,
            partnerId: company.partnerId,
            restrictOnePax: company.restrictOnePax,
            disableMiles: company.disableMiles
          },
          $event
        )
      "
      [attr.data-acdl-action]="
        'header profile flyout select a profile cta click'
      "
      [attr.data-acdl-page-section]="'header:profile selector flyout'"
      [attr.data-acdl-name]="'business profile'"
    >
      <div>
        <p class="businessProfileSelectorScreen__content--permission-title">
          {{ permissionCompany.title }}
        </p>
        <div
          class="businessProfileSelectorScreen__content--permission-description"
        >
          <p>{{ permissionCompany.description }}</p>
          <div class="type-list-arrow"></div>
        </div>
        <div
          *ngIf="show"
          [ngClass]="{ first: first, last: last }"
          class="businessProfileSelectorScreen__content--permission-divider"
        ></div>
      </div>
    </a>
  </div>
</div>

<!-- New MachCore Template -->
<div
  *ngIf="enableMachCoreProfileSelector"
  class="businessProfileSelectorMachCore"
>
  <p
    class="businessProfileSelectorMachCore__title font-semibold text-[13px] leading-4 text-[#0b1f66] mb-[16px]"
  >
    {{ pageData.title }}
  </p>

  <!-- Company List -->

  <div
    class="businessProfileSelectorMachCore__company"
    *ngFor="
      let company of pageData.businessProfile;
      let i = index;
      let first = first;
      let last = last
    "
  >
    <!-- Company Header -->
    <button
      type="button"
      (click)="
        isBusinessOnlyPath(company.permissionTypes)
          ? noExpand(
              {
                companyName: company.companyName,
                permType: company.permissionTypes,
                accountIndex: i,
                corporateId: company.corporateId,
                displayInlineText: company.displayInlineText,
                isOaSmeAccount: company.isOaSmeAccount,
                partnerId: company.partnerId,
                restrictOnePax: company.restrictOnePax,
                disableMiles: company.disableMiles
              },
              $event
            )
          : expand(i, $event)
      "
      [ngClass]="{
        selected:
          businessStateSelected.selectedState &&
          businessStateSelected.accountIndex === i,
        first: first,
        last: last,
        'only-business': isBusinessOnlyPath(company.permissionTypes)
      }"
      class="businessProfileSelectorMachCore__company-header w-full text-left"
      [attr.data-acdl-action]="
        'header profile selector flyout:select business profile'
      "
      [attr.data-acdl-event-detail]="
        'header profile flyout select a profile cta click'
      "
      [attr.data-acdl-page-section]="'header:profile selector flyout'"
      [attr.data-acdl-name]="'business profile'"
    >
      <details
        class="accordion accordion-base mb-[8px]"
        [id]="'multi-select-accordion-' + i"
        name="multi-select-accordion"
      >
        <summary>
          <div
            [ngClass]="{
              'bg-[#6c718a]':
                businessStateSelected.selectedState &&
                businessStateSelected.accountIndex === i,
              'bg-[#f5f7fa]': !(
                businessStateSelected.selectedState &&
                businessStateSelected.accountIndex === i
              )
            }"
            class="businessProfileSelectorMachCore__summary accordion-summary h-[50.16px] hover:cursor-pointer hover:bg-[#6c718a] hover-text-white hover-icon-inverse"
          >
            <h6
              [ngClass]="{
                'text-inverse':
                  businessStateSelected.selectedState &&
                  businessStateSelected.accountIndex === i,
                'text-[#0b1f66]': !(
                  businessStateSelected.selectedState &&
                  businessStateSelected.accountIndex === i
                )
              }"
              class="businessProfileSelectorMachCore__company-name text-caption-semibold leading-4 text-left"
            >
              {{ company.displayName }}
            </h6>
            <span
              *ngIf="
                businessStateSelected.selectedState &&
                businessStateSelected.accountIndex === i
              "
              class="businessProfileSelectorMachCore__check-mark ml-auto"
              [ngClass]="{
                'businessProfileSelectorMachCore__check-mark--only-business':
                  isBusinessOnlyPath(company.permissionTypes)
              }"
            >
              <svg
                class="bg-[#fff] rounded-[100%] p-[2px]"
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.3725 0L4.5939 7.91196L1.35412 4.93899L0 6.51235L4.89104 11L12 1.26725L10.3725 0Z"
                  fill="#0B1F66"
                />
              </svg>
            </span>
            <div
              *ngIf="!isBusinessOnlyPath(company.permissionTypes)"
              [ngClass]="{
                'ml-auto': !(
                  businessStateSelected.selectedState &&
                  businessStateSelected.accountIndex === i
                )
              }"
              class="businessProfileSelectorMachCore__caret accordion-caret"
            >
              <svg
                [ngClass]="{
                  'text-inverse':
                    businessStateSelected.selectedState &&
                    businessStateSelected.accountIndex === i,
                  'text-icon-alert': !(
                    businessStateSelected.selectedState &&
                    businessStateSelected.accountIndex === i
                  )
                }"
                class="businessProfileSelectorMachCore__caret-icon accordion-caret-icon"
              ></svg>
            </div>
          </div>
        </summary>
        <div
          *ngIf="!isBusinessOnlyPath(company.permissionTypes)"
          class="businessProfileSelectorMachCore__content accordion-content flex flex-col gap-[16px] p-[1rem]"
        >
          <!-- Permission Types -->
          <a
            class="businessProfileSelectorMachCore__permission hover:underline hover:cursor-pointer"
            [ngClass]="{
              'businessProfileSelectorMachCore__permission--active': show,
              'businessProfileSelectorMachCore__permission--details':
                i === permissionDiv && show
            }"
            *ngFor="
              let permissionCompany of company.permissionTypes;
              let permLast = last
            "
            [id]="'businessProfile_' + i"
            href="javascript:void(0)"
            (click)="
              onClick(
                {
                  companyName: company.companyName,
                  permType: permissionCompany.permType,
                  accountIndex: i,
                  corporateId: company.corporateId,
                  displayInlineText: company.displayInlineText,
                  isOaSmeAccount: company.isOaSmeAccount,
                  partnerId: company.partnerId,
                  restrictOnePax: company.restrictOnePax,
                  disableMiles: company.disableMiles
                },
                $event
              )
            "
            [attr.data-acdl-action]="
              'header profile flyout select a profile cta click'
            "
            [attr.data-acdl-page-section]="'header:profile selector flyout'"
            [attr.data-acdl-name]="'business profile'"
          >
            <div>
              <p
                class="businessProfileSelectorMachCore__permission-title text-caption-semibold leading-[15.6px] text-[#0b1f66] pb-[.25rem]"
              >
                {{ permissionCompany.title }}
              </p>
              <div
                class="businessProfileSelectorMachCore__permission-description flex justify-between text-[#697180]"
              >
                <p
                  class="businessProfileSelectorMachCore__permission-text w-[230px] text-[13px] leading-4"
                >
                  {{ permissionCompany.description }}
                </p>
                <div class="businessProfileSelectorMachCore__arrow"></div>
              </div>
              <div
                *ngIf="show"
                [ngClass]="{ 'border border-[#e8ecf2]': !permLast }"
                class="businessProfileSelectorMachCore__permission-divider mt-[12px]"
              ></div>
            </div>
          </a>
        </div>
      </details>
    </button>
  </div>
</div>
